import styled from "styled-components";
import CommonButton from "components/common/ui/CommonButton";

const PillButton = styled(CommonButton)`
  border-radius: 1.5rem;
`;

export default PillButton;
